import React, { createContext, useContext, useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = logged out, object = logged in
  const [settings, setSettings] = useState(null);

  const loadSettings = async () => {
    try {
      const { data } = await api.get("/settings");
      setSettings(data);
    } catch (e) {
      /* ignore */
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("mt_token");
    if (!token) {
      setUser(false);
      return;
    }
    api
      .get("/auth/me")
      .then(({ data }) => {
        setUser(data);
        loadSettings();
      })
      .catch(() => {
        localStorage.removeItem("mt_token");
        setUser(false);
      });
  }, []);

  const login = async (username, password) => {
    try {
      const { data } = await api.post("/auth/login", { username, password });
      localStorage.setItem("mt_token", data.token);
      setUser(data.user);
      await loadSettings();
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiErrorDetail(e.response?.data?.detail) || "Login failed" };
    }
  };

  const logout = () => {
    localStorage.removeItem("mt_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, settings, setSettings, loadSettings }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
